import {LanguageModel} from '../../translation/translation.models';
import {FileManager} from '../../shared/Models/FileManager';


export class Email {
  static EMAIL_ACTIVE = 'active';
  static EMAIL_INACTIVE = 'inactive';
  static EMAIL_YES = 'yes';
  static EMAIL_NO = 'no';

  public id: number;
  public active: boolean;
  public event: string;
  public subject: string;
  public body: string;
  public bodyMapping: string[];
  public preHeader: string;
  public to: string;
  public cc: string[];
  public bcc: string[];
  public hasCopy: boolean;
  public copyTo?: string;
  public copyCc?: string[];
  public copySubject?: string;
  public copyBody?: string;
  public copyBodyMapping?: string[];
  public copyPreHeader?: string;
  public language: LanguageModel | number;
  public attachments: FileManager[] = [];

}
